/* Copyright 2013 - 2024 Waiterio LLC */
import { css } from '@emotion/react'

export default css({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
})
